<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">مواعيد العيادات الخارجية وساعات العمل</h3>
            <p class="depth">يمكنك تحديد موعد عبر الهاتف أو البريد الإلكتروني، أو من خلال موقعنا على الإنترنت. لتحديد موعد وعلاج، سيطلب منك تقديم معلوماتك الشخصية ووصف الأعراض التي تشعر بها بالتفصيل.</p>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: 25%">
                        <col style="width: auto">
                        <col style="width: 15%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">للحصول على معلومات حول كيفية تحديد موعد</th>
                            <th scope="col">والإجراءات</th>
                            <th scope="col">والساعات المتوفرة</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>مكالمة</td>
                            <td>يرجى الاتصال بالمركز الدولي للرعاية الصحية (+82-6986-3100)</td>
                            <td>09:00 ~ 17:00</td>
                        </tr>
                        <tr>
                            <td>البريد الإلكتروني</td>
                            <td><a href="mailto:eumcint@gmail.com">eumcint@gmail.com</a></td>
                            <td>24 ساعة</td>
                        </tr>
                        <tr>
                            <td>موقع الكتروني</td>
                            <td>
                                <div style="display: ruby;">
                                    يمكنك أيضا طلب موعد عبر الإنترنت من خلال الموقع الخاص
                                    &nbsp;&nbsp;
                                    <a href="/eng/reservation/reservation.do"
                                        class="main-button small c-main">موعد</a>
                                </div>
                            </td>
                            <td>24 ساعة</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">تغيير أو إلغاء العلاج (الموعد)</h3>
            <p class="depth">
                إذا لم تتمكن من حضور موعد العيادات الخارجية لأي سبب من الأسباب، فيرجى الاتصال بنا قبل الموعد بيوم على الأقل لتغيير الموعد أو إلغائه.
            </p>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: 25%;">
                        <col>
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">للحصول على معلومات حول كيفية تحديد موعد</th>
                            <th scope="col">والإجراءات</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>مكالمة</td>
                            <td>يرجى الاتصال بالمركز الدولي للرعاية الصحية (+82-6986-3100)</td>
                        </tr>
                        <tr>
                            <td>البريد الإلكتروني</td>
                            <td><a href="mailto:eumcint@gmail.com">eumcint@gmail.com</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>